'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageControlPointDuplicate = function ImageControlPointDuplicate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z' })
  );
};
ImageControlPointDuplicate = (0, _pure2.default)(ImageControlPointDuplicate);
ImageControlPointDuplicate.displayName = 'ImageControlPointDuplicate';
ImageControlPointDuplicate.muiName = 'SvgIcon';

exports.default = ImageControlPointDuplicate;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/control-point-duplicate.js
 ** module id = 2050
 ** module chunks = 0
 **/